import React, { useState, useEffect } from "react";
import expe from "../../../assets/images/xp.png";
import fire from "../../../assets/images/fire_icon.png";

import { user, client, session } from "../../../utils/nakama";

import "./ShopNav.css";

import { Row, Image, Toast, ToastContainer } from "react-bootstrap";

export default function PlayerInfo(props) {
  const [objects, setObjects] = useState(null);
  const [exp, setExp] = useState(null);
  const [boneStreak, setBoneStreak] = useState(null);
  const [isNotFriend, setIsNotFriend] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [showRedToast, setShowRedToast] = useState(false);
  const [isBonePending, setIsBonePending] = useState(null);
  const [nextBoneTime, setNextBoneTime] = useState(null);
  const [isFriendPending, setIsFriendPending] = useState(false);
  const [isFriendReceived, setIsFriendReceived] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [buttonClickedCollect, setButtonClickedCollect] = useState(false);
  const [mySpecprofile, setMySpecprofile] = useState(false);
  const currentTimestamp = Date.now(); 
  const [profile, setProfile] = useState(null);
  const [name, setName] = useState(null);

  useEffect(() => { 
    let targetUserId;
    if (window.Phaser.PlayerInfo) {
      targetUserId = props.gameData.opponent.userId;
      getFriends(targetUserId);
    }
    else if (window.Phaser.MyInfo) {
      targetUserId = props.gameData.player.userId;
      getFriends(targetUserId);
    }
    else if (window.Phaser.SpectatorInfo) {
      targetUserId = window.Phaser.SpectatorId;
      const getSpectatorInfo = async (retryCount = 0) => {
        const maxRetries = 2;
        const retryDelay = 1000 * (retryCount + 1);
        
        try {
          const response = await client.getUsers(session, [targetUserId]);
          setProfile(response.users[0].avatar_url);
          setName(response.users[0].username);
        }
        catch (e) {
          console.log("getUsers error", e);
          
          // Retry on server errors (500) but not on authentication errors
          if (retryCount < maxRetries && 
              (e.message?.includes('500') || e.message?.includes('Internal Server Error'))) {
            console.log(`Retrying getUsers in ${retryDelay}ms... (attempt ${retryCount + 1}/${maxRetries})`);
            setTimeout(() => getSpectatorInfo(retryCount + 1), retryDelay);
            return;
          }
          
          // Don't call sessionTimeoutCheck for server errors, only for auth errors
          if (e.code === 16 || e.message?.includes('UNAUTHENTICATED') || e.message?.includes('session')) {
            console.log("Authentication error in getUsers, checking session...");
            // Could call sessionTimeoutCheck here if needed
          }
        }
      };  getSpectatorInfo();
      getFriends(targetUserId);
    }
    if (window.Phaser.SpectatorId === user.id) {
      setMySpecprofile(true); //check if I clicked on my own spectator profile
    }
    getUserInfo();
  }, [window.Phaser.PlayerInfo, window.Phaser.MyInfo, window.Phaser.SpectatorInfo, window.Phaser.SpectatorId]);

  async function addFriends() {
    try {
      if(window.Phaser.PlayerInfo) {
      await client.addFriends(
        session,
        props.gameData.opponent.userId,
        props.gameData.opponent.username.substring(0, 14)
      );
      }
      else if(window.Phaser.MyInfo && props.isSpectator) {
        await client.addFriends(
          session,
          props.gameData.player.userId,
          props.gameData.player.username.substring(0, 14)
        );
      }
      else if(window.Phaser.SpectatorInfo) {
        await client.addFriends(
          session,
          window.Phaser.SpectatorId,
          props.gameData.player.username.substring(0, 14)
        );
      }
    } catch (error) {
        console.log("addFriends() error", error);
    }
    let targetUserId;
    if (window.Phaser.PlayerInfo) {
      targetUserId = props.gameData.opponent.userId;
      getFriends(targetUserId);
    }
    else if (window.Phaser.MyInfo) {
      targetUserId = props.gameData.player.userId;
      getFriends(targetUserId);
    }
    else if(window.Phaser.SpectatorInfo) {
      targetUserId = window.Phaser.SpectatorId;
      getFriends(targetUserId);
    }
    getUserInfo();
  }


  async function accept() {
    try {
      if(window.Phaser.PlayerInfo) {
      await client.addFriends(
        session,
        props.gameData.opponent.userId,
        props.gameData.opponent.username.substring(0, 14)
      );
      }
      else if(window.Phaser.MyInfo && props.isSpectator) {
        await client.addFriends(
          session,
          props.gameData.player.userId,
          props.gameData.player.username.substring(0, 14)
        );
      }
      else if(window.Phaser.SpectatorInfo) {
        await client.addFriends(
          session,
          window.Phaser.SpectatorId,
          props.gameData.player.username.substring(0, 14)
        );
      }
    } catch (error) {
        console.log("addFriends() error", error);
    }
    let targetUserId;
    if (window.Phaser.PlayerInfo) {
      targetUserId = props.gameData.opponent.userId;
      getFriends(targetUserId);
    }
    else if (window.Phaser.MyInfo) {
      targetUserId = props.gameData.player.userId;
      getFriends(targetUserId);
    }
    else if(window.Phaser.SpectatorInfo) {
      targetUserId = window.Phaser.SpectatorId;
      getFriends(targetUserId);
    }
    getUserInfo();
  }

  async function getUserInfo() { //for opponent info as player
    try{
      const response = await client.readStorageObjects(session, {
        object_ids: [
          {
            collection: "bone_streaks",
            key: "bone_streaks",
            user_id: props.gameData.player.userId,
          },
          {
            collection: "bonez_matches",
            key: "bonez_matches",
            user_id: props.gameData.opponent.userId,
          },
          {
            collection: "user_levels",
            key: "user_levels",
            user_id: props.gameData.opponent.userId,
          }, 
        ],
      });
      const myresponse = await client.readStorageObjects(session, {
        object_ids: [
          {
            collection: "bonez_matches",
            key: "bonez_matches",
            user_id: props.gameData.player.userId,
          },
          {
            collection: "user_levels",
            key: "user_levels",
            user_id: props.gameData.player.userId,
          },  
        ],
      });
      const spectatorresponse = await client.readStorageObjects(session, {
        object_ids: [
          {
            collection: "bone_streaks",
            key: "bone_streaks",
            user_id: user.id,
          }, 
        ],
      });

      const otherresponse = await client.readStorageObjects(session, { //for viewing other spectator info
        object_ids: [
          {
            collection: "bone_streaks",
            key: "bone_streaks",
            user_id: user.id,
          },
          {
            collection: "bonez_matches",
            key: "bonez_matches",
            user_id: window.Phaser.SpectatorId,
          },
          {
            collection: "user_levels",
            key: "user_levels",
            user_id: window.Phaser.SpectatorId,
          },  
        ],
      });
      console.log('first call');
      const processresults = async () => {
        console.log('called hree');
        if(!props.isSpectator && window.Phaser.PlayerInfo) {   //opponent info for player
          const opponentid = props.gameData.opponent.userId;
            setObjects(response.objects[1].value.data);
            setExp(response.objects[2].value.data.xp);
            try {
              setNextBoneTime(response.objects[0].value.data[opponentid].nextBoneTime);
              setBoneStreak(response.objects[0].value.data[opponentid].streakCount);
              setIsBonePending(response.objects[0].value.data[opponentid].bonePending);
            }
            catch(e) {
              console.log("streak not working", e);
            }
        }
        else if(!props.isSpectator && window.Phaser.MyInfo) {
            setObjects(myresponse.objects[0].value.data);
            setExp(myresponse.objects[1].value.data.xp);
        }
        else if(window.Phaser.PlayerInfo) {
          const opponentid = props.gameData.opponent.userId;
          setObjects(response.objects[0].value.data);
          setExp(response.objects[1].value.data.xp);
          console.log('010101 2');
          try {
              setNextBoneTime(spectatorresponse.objects[0].value.data[opponentid].nextBoneTime);
              setIsBonePending(spectatorresponse.objects[0].value.data[opponentid].bonePending);
              setBoneStreak(spectatorresponse.objects[0].value.data[opponentid].streakCount);
              console.log('010101', nextBoneTime, spectatorresponse.objects[0].value.data[opponentid].nextBoneTime);
          }
          catch(e) {
            // console.log("streak not working", e); this error is expected if we are not friends
          }
        }
        else if(window.Phaser.MyInfo) {
          const playerid = props.gameData.player.userId;
          setObjects(myresponse.objects[0].value.data);
          setExp(myresponse.objects[1].value.data.xp);
          try {
            //Check following datas only when spectators are friends with the player
              setNextBoneTime(spectatorresponse.objects[0].value.data[playerid].nextBoneTime);
              setIsBonePending(spectatorresponse.objects[0].value.data[playerid].bonePending);
              setBoneStreak(spectatorresponse.objects[0].value.data[playerid].streakCount);
          }
          catch (e) {
            // console.log("streak not working", e); this error is expected if we are not friends
          }
        }
        else if(window.Phaser.SpectatorInfo) {   //opponent info for player
          setObjects(otherresponse.objects[1].value.data);
          setExp(otherresponse.objects[2].value.data.xp);
          try {
            const specid = window.Phaser.SpectatorId;
              setNextBoneTime(otherresponse.objects[0].value.data[specid].nextBoneTime);
              setBoneStreak(otherresponse.objects[0].value.data[specid].streakCount);
              setIsBonePending(otherresponse.objects[0].value.data[specid].bonePending);
          }
          catch(e) {
            // console.log("streak not working", e); this error is expected if we are not friends
          }
        }
      }; processresults();
    }
    catch(e){
      console.log(e);
    } 
   }

  async function getFriends(targetUserId) {
    try {
    var result = await client.listFriends(session);
    var friendMap = new Map();
    for (var friend in result.friends) {
      const friendData = result.friends[friend].user;
      friendMap.set(
        friendData.id,
        result.friends[friend].state
      );    
    if (friendMap.has(targetUserId)) {
      const friendState = friendMap.get(targetUserId);
      if (friendState === 0) {
        setIsNotFriend(false);
        setIsFriendReceived(false);
        setIsFriendPending(false);
      } else if (friendState === 1) {
        setIsNotFriend(true);
        setIsFriendPending(true);
        setIsFriendReceived(false);
      } else if (friendState === 2) {
        setIsNotFriend(true);
        setIsFriendReceived(true);
        setIsFriendPending(false);
      } else {
        setIsNotFriend(true);
        setIsFriendPending(false);
        setIsFriendReceived(false);
      }
    }
    }
    }
    catch(e){
      console.log("getfriend error", e);
    }
    };

  const sendBone = async (friend) => {
    const sendButton = document.querySelector(".send");
    if (sendButton) {
      sendButton.style.visibility = "hidden";
    }

    try {
      if(window.Phaser.PlayerInfo) {
        const res = await client.rpc(session, "updateBoneStreak", {
          player: user.id,
          otherPlayer: props.gameData.opponent.userId,
          state: "send",
        });
        if (res.payload.message === undefined) {
          setShowToast(true);
        } else {
          setShowRedToast(true);
        }
      }
      else if(window.Phaser.MyInfo) {
        const res = await client.rpc(session, "updateBoneStreak", {
          player: user.id,
          otherPlayer: props.gameData.player.userId,
          state: "send",
        });
        if (res.payload.message === undefined) {
          setShowToast(true);
        } else {
          setShowRedToast(true);
        }
      }
      else if(window.Phaser.SpectatorInfo) {
        const res = await client.rpc(session, "updateBoneStreak", {
          player: user.id,
          otherPlayer: window.Phaser.SpectatorId,
          state: "send",
        });
        if (res.payload.message === undefined) {
          setShowToast(true);
        } else {
          setShowRedToast(true);
        }
      }
    } catch (err) {
      console.log("error here", err);
    }
  };
  const collectBone = async (friend) => {
    const sendButton = document.querySelector(".container-body-text.send1");
    if (sendButton) {
      sendButton.style.visibility = "hidden";
    }
    try {
      if(window.Phaser.PlayerInfo) {
        const res = await client.rpc(session, "updateBoneStreak", {
          player: user.id,
          otherPlayer: props.gameData.opponent.userId,
          state: "get",
        });
        if (res.payload.message === undefined) {
          setShowToast(true);
        } else {
          setShowRedToast(true);
        }
      }
      else if(window.Phaser.MyInfo) {
        const res = await client.rpc(session, "updateBoneStreak", {
          player: user.id,
          otherPlayer: props.gameData.player.userId,
          state: "get",
        });
        if (res.payload.message === undefined) {
          setShowToast(true);
        } else {
          setShowRedToast(true);
        }
      }
      else if(window.Phaser.SpectatorInfo) {
        const res = await client.rpc(session, "updateBoneStreak", {
          player: user.id,
          otherPlayer: window.Phaser.SpectatorId,
          state: "get",
        });
        if (res.payload.message === undefined) {
          setShowToast(true);
        } else {
          setShowRedToast(true);
        }
      }
      
    
    } catch (err) {
      console.log("error here", err);
    }
  };

  return (
   <>
    {!(!window.Phaser.MyInfo && !window.Phaser.PlayerInfo && !window.Phaser.SpectatorInfo) && (
    <>
      <ToastContainer
        className="p-3"
        position={"bottom-start"} // Set the position here
        style={{ zIndex: 1 }}
      >
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          className="d-inline-block m-1"
          bg={"success"}
          style={{ maxWidth: "400px", minHeight: "15px", fontSize: "14px" }}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Success</strong>
          </Toast.Header>
          <Toast.Body
            className={`text-white ${
              "success" === "Dark" && "font-weight-bold"
            }`}
            style={{ textAlign: "left" }}
          >
            Success
          </Toast.Body>
        </Toast>
      </ToastContainer>

      <ToastContainer
        className="p-3"
        position={"bottom-start"} // Set the position here
        style={{ zIndex: 1 }}
      >
        <Toast
          onClose={() => setShowRedToast(false)}
          show={showRedToast}
          className="d-inline-block m-1"
          bg={"danger"}
          style={{ maxWidth: "400px", minHeight: "15px", fontSize: "14px" }}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Fail</strong>
          </Toast.Header>
          <Toast.Body
            className={`text-white ${
              "danger" === "Dark" && "font-weight-bold"
            }`}
            style={{ textAlign: "left" }}
          >
            Fail
          </Toast.Body>
        </Toast>
      </ToastContainer>
 
      <div className="Shop-top" style={{marginTop:"-10px"}}>
      {window.Phaser.PlayerInfo && <Image
          roundedCircle
          className="playerinfoimg"
          alt=""
          src={
            (props.gameData.opponent.avatarUrl)
          }          
        />}
        {window.Phaser.MyInfo && <Image
          roundedCircle
          className="playerinfoimg"
          alt=""
          src={
            (props.gameData.player.avatarUrl)
          }          
        />}
        
        {window.Phaser.SpectatorInfo && <Image
          roundedCircle
          className="playerinfoimg"
          alt=""
          src={
            (profile)
          }          
        />}
         
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "5%",
            marginLeft: "12%",
          }}
        >
          <span
            className="container-body-text data"
            style={{color: "skyblue", marginTop: "5%" }}
          >
            {window.Phaser.PlayerInfo && props.gameData.opponent.username.substring(0, 14)}
             {window.Phaser.MyInfo  &&props.gameData.player.username.substring(0, 14)}
             {mySpecprofile && user.username.substring(0, 14)}
             {!mySpecprofile && window.Phaser.SpectatorInfo && name}
          </span>
          
        </div>
      </div>


      {!isFriendPending && !isFriendReceived && !buttonClicked && isNotFriend && objects
       && !(!props.isSpectator && window.Phaser.MyInfo) && !mySpecprofile && 
      (
        <button
          className="button invite add"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "2px",
          }}
          // onClick={addFriends}
          onClick={(e) => {
            setButtonClicked(true);
            addFriends();
            setIsNotFriend(true);
            setIsFriendPending(true);
            setIsFriendReceived(false);
            e.stopPropagation();
         
          }}
        >
          <img
            className="green-button-10000"
            src="https://zoombies.world/images/dapp/green_button_400.webp"
            alt=""
          />
          <span className="button-text" style={{ fontSize: "15px" }}>
            Add Friend
          </span>
        </button>
      )}

      {isFriendPending&& isNotFriend && !(!props.isSpectator && window.Phaser.MyInfo) && !mySpecprofile && (
        <span
          className="container-body-text datahead1"
          style={{color: "red" }}
        >
          Friend request sent
        </span>
      )}

      {isFriendReceived && isNotFriend && !(!props.isSpectator && window.Phaser.MyInfo) && !mySpecprofile&&(
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <span className="container-body-text datahead1">
            Friend request received!
          </span>

          {!buttonClicked && <button
            className="button invite accept"
            style={{
              marginLeft: "20px", // Adjust the margin as needed
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "5px",
            }}
            onClick={(e) => {
              setButtonClicked(true);
              setIsNotFriend(true);
              setIsFriendPending(false);
              setIsFriendReceived(false);
              accept();
              e.stopPropagation();                   
 
            }}
            >
            <img
              className="green-button-10000"
              src="https://zoombies.world/images/dapp/green_button_400.webp"
              alt=""
            />
            <span className="button-text" style={{ fontSize: "15px" }}>
              ACCEPT
            </span>
          </button>}
        </div>
      )}
  {!isNotFriend && !mySpecprofile && !(!props.isSpectator && window.Phaser.MyInfo) &&
    <div class="container mt-3" style={{ display: "block" }}>
      <div class="row">
        <div class="col-5">
          <div class="row">
            <span
              className="container-body-text data"
              style={{color: "skyblue"}}
            >
              Bone Streak
            </span>
          </div>
          <div class="row">
            {isBonePending > 0 && !buttonClickedCollect && (
              <span
                className="container-body-text data"
                style={{ color: "red", marginTop: "-1%" }}
                onClick={(e) => {
                  collectBone();
                  getUserInfo();
                  setButtonClickedCollect(true);
                  e.stopPropagation();                   
              }}
              >
                Collect {isBonePending} &nbsp;
                <img
                  className="iconBonimgcollect"
                  title="Zoombies Chipz"
                  src="/bonez/static/media/bonez_icon.6e4f89abe3dccc870777d0d193cc60e3.svg"
                  alt="Chipz icon"
                />
              </span>
            )}
          </div>
        </div>

        <div class="col-4">
          {objects &&  <span
            className="container-body-text datahead"
            style={{color: "white", marginTop: "-1%" }}
          >
            <img
              className="fireiconprofile"
              alt=""
              src={fire}
            />
             {boneStreak && boneStreak.toLocaleString()}
          </span>}
        </div>
        <div class="col-sm">
          <div class="row">
            <div
              class="col send"
              onClick={(e) => {
                sendBone();
                getUserInfo();
                e.stopPropagation();
              }}
            >
              {currentTimestamp > nextBoneTime && (
                <>
                  <span
                    className="container-body-text data"
                    style={{

                      color: "lightgreen",
                      marginTop: "-20%",
                      marginRight: "-50px",
                    }}
                  >
                    Send 
                  </span>
                  <br />
                  <img
                    className="iconBonimg"
                    title="Send Bone"
                    src="/bonez/static/media/bonez_icon.6e4f89abe3dccc870777d0d193cc60e3.svg"
                    alt="Bonez icon"
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  }

      <div className="container text-center">
       {exp && 
        <span className="container-body-text datahead2 mt-3" style={{ color: "gold", marginTop: "-1%" }}>
          {" "}
          <img
            className="playerinfoiconstar"
            alt=""
            src={expe}
            style={{ height: "auto", marginBottom: "2px" }}
          />
          &nbsp;{exp.toLocaleString()}{" "}
        </span>}
      </div>
      
      
 
        {objects && (<span
          className="container-body-text datahead1"
          style={{ color: "orange", marginTop: "-1%" }}
        >
          {objects.winStreak && objects.winStreak.toLocaleString()}
          <img
            className="icon"
            alt=""
            src={fire}
            style={{
              width: "15%",
               height: "auto", 
               marginBottom: "5px",
               marginLeft: "5px",
            }}
          />{" "}
          Win Streak!
        </span>
        )}
 
      <span
        className="container-body-text datahead align"
        style={{ color: "skyblue", marginTop: "-1%"}}
      >
        BIGGEST
        <img
          className="playerinfoicon"
          title="Zoombies Chipz"
          src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
          style={{
            height: "auto",
            marginRight: "5px",
            marginLeft: "5px",
          }}
          alt="Chipz icon"
        />{" "}
        POT WON
      </span>
  
      {objects &&  (<span
          className="container-body-text datahead"
          style={{ color: "skyblue", marginTop: "-1%" }}
        >
          {objects.biggestPotWonChipz && objects.biggestPotWonChipz.toLocaleString()}{" "}
        </span>)}
      
      <span
        className="container-body-text datahead bones"
        style={{ color: "mint", marginTop: "-1%" }}
      >
        BIGGEST
        <img
          className="playerinfoicon"
          title="Zoombies Chipz"
          src="/bonez/static/media/bonez_icon.6e4f89abe3dccc870777d0d193cc60e3.svg"
          style={{
            width: "10%",
            height: "auto",
            marginRight: "5px",
            marginLeft: "5px",
          }}
          alt="Chipz icon"
        />{" "}
        POT WON
      </span>

      {objects &&(<span
          className="container-body-text datahead"
          style={{ color: "mint", marginTop: "-1%" }}
        >
          {objects.biggestPotWonBones&&objects.biggestPotWonBones.toLocaleString()}{" "}
        </span>)}
      

      <div class="container">
        <Row class="align-items-center">
          <div class="col-5" style={{ marginLeft: "20%" }}>
            <Row>

                <span
                  className="container-body-text data"
                  style={{ color: "gold", marginTop: "-1%" }}
                >
                  Games Played{" "}
                </span>
            </Row>
            <div class="row">

                <span
                  className="container-body-text data"
                  style={{ color: "#90EE90", marginTop: "-1%" }}
                >
                  Games Won{" "}
                </span>

            </div>
            <div class="row">

                <span
                  className="container-body-text data"
                  style={{ color: "pink", marginTop: "-1%" }}
                >
                  Rounds Won{" "}
                </span>

            </div>
            <div class="row">

                <span
                  className="container-body-text data"
                  style={{ color: "red", marginTop: "-1%" }}
                >
                  Games Lost{" "}
                </span>

            </div>
            <div class="row">

                <span
                  className="container-body-text data"
                  style={{
                    color: "#D8BFD8",
                    marginTop: "-1%",
                    marginBottom: "10%",
                  }}
                >
                  Forfeits
                </span>

            </div>
            
            <div class="row">
                <span
                  className="container-body-text data"
                  style={{ color: "skyblue", marginTop: "-1%" }}
                >
                  TOTAL
                  <img
                    className="playerinfoicon"
                    title="Zoombies Chipz"
                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                    alt="Chipz icon"
                  />
                  WON
                </span>
            </div>
            <div class="row">
                <span
                  className="container-body-text data"
                  style={{ color: "#6A5ACD", marginTop: "-1%" }}
                >
                  TOTAL
                  <img
                    className="playerinfoicon"
                    title="Zoombies Chipz"
                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"

                    alt="Chipz icon"
                  />
                  LOST{" "}
                </span>
            </div>
            <div class="row">

                <span
                  className="container-body-text data"
                  style={{ color: "mint", marginTop: "-1%" }}
                >
                  TOTAL
                  <img
                    className="playerinfoicon"
                    title="Zoombies Bonez"
                    src="/bonez/static/media/bonez_icon.6e4f89abe3dccc870777d0d193cc60e3.svg"

                    alt="Bonez icon"
                  />
                  WON{" "}
                </span>
            </div>
            <div class="row">
                <span
                  className="container-body-text data"
                  style={{ color: "#DEB887", marginTop: "-1%" }}
                >
                  TOTAL
                  <img
                className="playerinfoicon"
                    title="Zoombies Bonez"
                    src="/bonez/static/media/bonez_icon.6e4f89abe3dccc870777d0d193cc60e3.svg"

                    alt="Bonez icon"
                  />
                  LOST{" "}
                </span>
            </div>
          </div>

          <div class="col-3">
            <div class="row">
            {objects && (<span
                  className="container-body-text data"
                  style={{ color: "gold", marginTop: "-1%" }}
                >
                  {objects.totalGamesPlayed&&objects.totalGamesPlayed.toLocaleString()}
                </span>)}
            </div>
            <div class="row">
            {objects &&(<span
                  className="container-body-text data"
                  style={{ color: "#90EE90", marginTop: "-1%" }}
                >
                  {objects.wins&&objects.wins.toLocaleString()}{" "}
                </span>)}
            </div>
            <div class="row">
            {objects && (<span
                  className="container-body-text data"
                  style={{ color: "pink", marginTop: "-1%" }}
                >
                  {objects.totalRoundsWon&&objects.totalRoundsWon.toLocaleString()}{" "}
                </span>)}
            </div>
            <div class="row">
            {objects && (<span
                  className="container-body-text data"
                  style={{ color: "red", marginTop: "-1%" }}
                >
                  {" "}
                  {objects.losses&&objects.losses.toLocaleString()}{" "}
                </span>)}
            </div>
            <div class="row">
            {objects && (<span
                  className="container-body-text data"
                  style={{
                    color: "#D8BFD8",
                    marginTop: "-1%",
                    marginBottom: "12.5%",
                  }}
                >
                  {objects.forfeits&&objects.forfeits.toLocaleString()}{" "}
                </span>)}
            </div>
            <div class="row">
            {objects && (<span
                  className="container-body-text data"
                  style={{ color: "skyblue", marginTop: "-1%" }}
                >
                  {objects.zoomWon&&objects.zoomWon.toLocaleString()}{" "}
                </span>)}
            </div>
            <div class="row">
            {objects && (<span
                  className="container-body-text data"
                  style={{ color: "#6A5ACD", marginTop: "-1%" }}
                >
                  {objects.zoomLost&&objects.zoomLost.toLocaleString()}{" "}
                </span>)}
            </div>
            <div class="row">
            {objects &&(<span
                  className="container-body-text data"
                  style={{ color: "mint", marginTop: "-1%" }}
                >
                  {objects.bonezWon&&objects.bonezWon.toLocaleString()}{" "}
                </span>)}
            </div>
            <div class="row">
            {objects && (<span
                  className="container-body-text data"
                  style={{ color: "#DEB887", marginTop: "-1%" }}
                >
                  {" "}
                  {objects.bonezLost&&objects.bonezLost.toLocaleString()}{" "}
                </span>)}
            </div>
          </div>
        </Row>
      </div>
      </>)} </>
  );
}
